export default function getNavItems() {

    const navItems = [
        {
          name: 'Catalogue',
          link: '/'
        },
        {
          name: 'Cart',
          link: '/cart'
        },
        {
          name: 'Contact',
          link: '/contact'
        }
      ]

    return navItems
}